import React, { useCallback } from 'react';
import './RateAppModal.css';

const DEFAULTS = {
  title: 'Rate now',
  description: 'Thank you for using the Alibaba.com app. We value your feedback!',
  imageUrl:
    'https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=720&h=420&fit=crop&q=80',
  primaryLabel: 'Yes, I love it!',
  secondaryLabel: 'I have an issue',
  appStoreUrl: 'https://apps.apple.com/',
  playStoreUrl: 'https://play.google.com/store',
  webReviewUrl: '',
  feedbackPath: '/mobile/help-centre'
};

function pickStoreUrl(cfg) {
  if (typeof navigator === 'undefined') return cfg.playStoreUrl || cfg.appStoreUrl;
  const ua = navigator.userAgent || '';
  if (/iPhone|iPad|iPod/i.test(ua)) return cfg.appStoreUrl || cfg.playStoreUrl;
  if (/Android/i.test(ua)) return cfg.playStoreUrl || cfg.appStoreUrl;
  return cfg.webReviewUrl || cfg.playStoreUrl || cfg.appStoreUrl;
}

export default function RateAppModal({ open, onClose, config, onIssue }) {
  const c = { ...DEFAULTS, ...(config || {}) };

  const onLoveIt = useCallback(() => {
    const url = pickStoreUrl(c);
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
    onClose();
  }, [c, onClose]);

  if (!open) return null;

  return (
    <div className="mrate-dim" role="presentation" onClick={onClose}>
      <div
        className="mrate-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mrate-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="mrate-x" onClick={onClose} aria-label="Close">
          ×
        </button>
        <div className="mrate-img-wrap">
          <img className="mrate-img" src={c.imageUrl} alt="" />
        </div>
        <h2 id="mrate-title" className="mrate-title">
          {c.title}
        </h2>
        <p className="mrate-desc">{c.description}</p>
        <button type="button" className="mrate-primary" onClick={onLoveIt}>
          {c.primaryLabel}
        </button>
        <button type="button" className="mrate-secondary" onClick={onIssue}>
          {c.secondaryLabel}
        </button>
      </div>
    </div>
  );
}
